var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1",
    clipPath: "url(#clip0_1775_1251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.1201 59.9595L21.9392 38.025L0.00463867 27.844L59.0486 0.943115L32.1201 59.9595Z",
    fill: "#2C3422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.0486 0.943115L0.00463867 27.844L15.4278 27.8991C18.9595 27.8991 22.4083 26.8232 25.3053 24.7814L59.0486 0.943115Z",
    fill: "url(#paint0_linear_1775_1251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.7803 18.3382C43.5208 20.0792 45.0679 21.8754 46.4492 23.6716C52.3336 31.4367 54.4608 39.2294 51.118 42.5455C49.2395 44.4246 45.952 44.5627 42.0289 43.2916C43.9352 43.7061 45.427 43.5126 46.3387 42.6007C48.383 40.5558 46.8083 35.4436 42.8301 29.7786C41.2554 27.568 39.3216 25.2743 37.1115 23.036C29.1551 15.0775 20.3975 10.9324 17.552 13.7787C16.6403 14.6906 16.4469 16.2105 16.8613 18.0896C15.5628 14.1932 15.701 10.8771 17.5796 8.99801C21.6683 4.9082 32.5255 9.08091 41.7803 18.3382Z",
    fill: "#FFCD47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.6059 9.35868C55.8205 14.5733 58.083 20.7812 55.6826 23.1816C54.579 24.2852 52.6752 24.4231 50.4404 23.7334C51.5165 23.9542 52.3993 23.8162 52.9511 23.2643C54.6342 21.5813 52.3442 16.5874 47.8745 12.1177C47.7089 11.9522 47.5434 11.7866 47.3778 11.6487C43.0185 7.48252 38.3281 5.41322 36.7003 7.04107C36.176 7.56529 36.038 8.44818 36.2588 9.55181C35.5691 7.31697 35.6794 5.41322 36.8107 4.30959C38.4661 2.65415 41.8597 3.17837 45.5017 5.33045C47.1847 6.32371 48.9505 7.67565 50.6059 9.35868Z",
    fill: "#FFCD47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.9392 38.0244L24.4223 39.1832C26.8227 40.2869 28.5609 42.4941 29.0851 45.0876L32.1201 59.959L21.9392 38.0244Z",
    fill: "url(#paint1_linear_1775_1251)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1775_1251",
    x1: 71.823,
    y1: 54.5262,
    x2: 22.5977,
    y2: 7.81225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1775_1251",
    x1: 26.1661,
    y1: 30.7987,
    x2: 27.4218,
    y2: 56.9184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1775_1251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59.0164,
    fill: "white",
    transform: "translate(0 0.943115)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon);
export default __webpack_public_path__ + "static/media/footerIcon.571cd081cb55b4edfb7ac973efb9a3e5.svg";
export { ForwardRef as ReactComponent };